var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCapsule = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8038_3096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1294 1.87073C16.8824 0.624002 15.2463 0 13.6121 0C11.976 0 10.3418 0.624002 9.09408 1.87073L5.47943 5.48381L1.86543 9.09689C0.194186 10.7677 -0.351397 13.1328 0.217184 15.2628C0.497003 16.3128 1.04259 17.306 1.86607 18.1299C3.11312 19.376 4.74795 20 6.38278 20C6.58721 20 6.79164 19.9898 6.99544 19.9706C8.42072 19.8346 9.80896 19.2208 10.9001 18.1293L14.5148 14.5162L18.1281 10.9037C20.6229 8.40902 20.6229 4.36482 18.1294 1.87073ZM13.6121 13.6131L8.64305 8.64533L8.23035 8.23274L8.64305 8.64533L4.80289 12.4839C4.42852 12.8581 3.82224 12.8581 3.44788 12.4839C3.07351 12.1096 3.07351 11.5035 3.44788 11.1292L7.28803 7.29003L6.38278 6.38692L9.99678 2.77384C10.9621 1.80878 12.2462 1.27738 13.6121 1.27738C14.9773 1.27738 16.2608 1.80878 17.2254 2.77384C19.2174 4.76592 19.2174 8.00792 17.2254 10.0006L13.6121 13.6131Z",
    fill: "#4AAF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3116 4.58067C12.3116 4.32711 12.2106 4.08313 12.0305 3.90302C11.6561 3.52875 11.0498 3.52875 10.6754 3.90302L7.2876 7.29L8.64261 8.64531L12.0311 5.25769C12.2106 5.07821 12.3116 4.83487 12.3116 4.58067Z",
    fill: "#4AAF4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8038_3096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCapsule);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/capsule.9a3344787af53aaf0961c805a91b61da.svg";